<template>
  <div>
    <LoadingOverlay :loading="loading" />
    <!-- Error state -->
    <div v-if="errorMsg" class="agency-error">
      {{ errorMsg }}
    </div>
    <div class="agency-hostList-boxes" ref="scrollBox" @scroll="handleScroll">
      <template v-if="agencyHostListData.length > 0">
          <div class="d-flex justify-content-between align-items-center hostCard-topBoxes agency-hostList-box"
            v-for="agencyHostData in agencyHostListData" :key="agencyHostData.id">
            <div class="d-flex align-items-center hostCard-leftBox">
              <div class="d-flex align-items-center hostCard-imageBox">
                <img
                  :src="agencyHostData.profile_images && agencyHostData.profile_images.length ? agencyHostData.profile_images[0].image_name : defaultProfile"
                  alt="host profile image" @error="onImageError" />
              </div>
              <div class="hostCard-infoBox">
                <div class="hostCard-name">{{ agencyHostData.name }}</div>
                <div class="hostCard-ID">ID: {{ agencyHostData.profile_id }}</div>
              </div>
            </div>
            <div class="d-flex align-items-center agencyTeam-statusBox"
              :class="agencyHostData.is_admin_block === 1 ? 'blocked' : 'verified'">
              {{ agencyHostData.is_admin_block === 1 ? 'Blocked' : 'Verified' }}
            </div>
          </div>
      </template>
      <!-- Empty state (only when not loading and no error) -->
      <div v-else-if="!loading && !errorMsg" class="agency-empty" aria-live="polite">
        No data
      </div>

    </div>
  </div>
</template>

<script>
import axios from 'axios';
import './AgencyCentreStyle.css';
import defaultProfile from '../../assets/images/default_profile.webp';
import LoadingOverlay from '../LoadingOverlay.vue';

// Base URL -> zeep.live (or override with env)
const API_BASE =
  (import.meta?.env?.VITE_API_BASE_URL) ||
  (typeof process !== 'undefined' && process.env?.VUE_APP_API_BASE_URL) ||
  'https://starmate.co.in/api';

const api = axios.create({ baseURL: API_BASE });

export default {
  name: 'AgencyHostListTabCont',
  components: { LoadingOverlay },
  data() {
    return {
      agencyHostListData: [],
      defaultProfile,
      loading: false,
      currentPage: 1,
      nextPageUrl: null,
      noMoreData: false,
      authToken: '',
      errorMsg: '',
    };
  },
  async mounted() {
    // read token from /agency-team-list/token=<JWT> or ?token=<JWT>
    const raw = this.$route.params.token || this.$route.query.token || '';
    this.authToken = this.normalizeToken(raw);

    if (!this.authToken) {
      console.error('JWT token missing in URL. Expected /agency-team-list/token=<JWT>');
      return;
    }

    // set token for all requests on this page
    api.defaults.headers.common.Authorization = `Bearer ${this.authToken}`;

    // optional: debug final URL
    api.interceptors.request.use((cfg) => {
      try {
        new URL((cfg.baseURL || '') + '/' + (cfg.url || ''));
        // console.log('[API] →', cfg.method?.toUpperCase(), full.toString(), cfg.params || '');
      } catch {

        // ignore URL parse errors
       }
      return cfg;
    });

    await this.fetchAgencyHostListData();
  },
  methods: {
    normalizeToken(v) {
      if (!v || typeof v !== 'string') return '';
      return v.startsWith('token=') ? v.slice(6) : v;
    },

    async fetchAgencyHostListData() {
      if (this.loading || this.noMoreData) return;
      this.loading = true;

      try {
        // NOTE: no userid — the backend infers from Bearer token
        const { data } = await api.get('hostlistfromagency', {
          params: { page: this.currentPage },
        });

        const result = data?.result;
        if (!result || !result.data) {
          this.noMoreData = true;
          return;
        }

        const { data: rows, next_page_url } = result;

        if (Array.isArray(rows) && rows.length > 0) {
          this.agencyHostListData.push(...rows);
          this.currentPage++;
          this.nextPageUrl = next_page_url;
        }

        if (!next_page_url || !rows?.length) {
          this.noMoreData = true;
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        // stop trying on 401/403
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          this.errorMsg = error?.userMessage || 'Unauthorized. Please check your token.'
          this.noMoreData = true;
        } else if (error?.userMessage) {
          this.errorMsg = error.userMessage
        } else {
          this.errorMsg = 'Something went wrong while fetching data.'
        }
      } finally {
        this.loading = false;
      }
    },

    onImageError(e) {
      e.target.src = this.defaultProfile;
    },

    handleScroll() {
      const box = this.$refs.scrollBox;
      if (!box) return;
      if (box.scrollTop + box.clientHeight >= box.scrollHeight - 5) {
        if (!this.noMoreData) this.fetchAgencyHostListData();
      }
    },
  },
};
</script>
